import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { formatDate } from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/formatters/format-date';
import { GatewayChargingSessionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/charging-sessions/gateway-charging-session.model';
import { CellContext } from '@tanstack/react-table';

import i18n from '@app/core/locale/i18n';

interface EmspBoChargingSessionListStartedAtCellProps
  extends CellContext<
    GatewayChargingSessionModel,
    GatewayChargingSessionModel['startedAt']
  > {}

export const EmspBoChargingSessionListStartedAtCell = ({
  getValue,
}: EmspBoChargingSessionListStartedAtCellProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  // Nothing to do

  // RENDER ////////////////////////////////////////////////////////////////////

  // TODO: `started at` may be optionnal, but the interface does not reflect
  // it, we should check with the backend team if it can be optionnal or not,
  // and update the interface if needed

  return (
    <Text truncate>{getValue() ? formatDate(getValue()!, i18n) : '—'}</Text>
  );
};
